import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from 'components/shared/Button';

const { useEffect } = React;

export type CartStatusProps = {
  onClick: React.MouseEventHandler;
  cartCount: number;
  showCartNotification?: boolean;
  setShowCartNotification?: (set: boolean) => void;
  confirmationMessage?: string;
};

function CartStatus({
  onClick,
  cartCount,
  showCartNotification = false,
  setShowCartNotification = () => {},
  confirmationMessage = '',
}: CartStatusProps) {
  const notificationId = 'add_to_cart_notification';

  const removeNotification = () => {
    const elem = document.getElementById(notificationId);
    if (elem) {
      elem.classList.add('hide');
      elem.removeEventListener('animationend', removeNotification);
    }
    setShowCartNotification(false);
  };

  function animateNotificationIn() {
    const elem = document.getElementById(notificationId);
    if (elem) {
      elem.classList.remove('hide');
      elem.classList.add('slideInDown');
    }
  }

  function animateNotificationOut() {
    const elem = document.getElementById(notificationId);
    if (elem) {
      elem.classList.add('fadeOut');
      elem.classList.remove('slideInDown');
      elem.addEventListener('animationend', removeNotification);
    }
  }

  useEffect(() => {
    if (showCartNotification) {
      animateNotificationIn();
      // show notification for 4 seconds before fading out.
      // listen for the animation to end and remove the notification
      window.setTimeout(() => {
        animateNotificationOut();
      }, 4000);
    }
  }, [showCartNotification]);

  return (
    <Button type="cornered" id="cart_status_view" className="cart_status" onClick={onClick}>
      <FontAwesomeIcon icon="shopping-cart" />
      <span className="screen-reader-text">Your Cart</span>
      <span>{cartCount}</span>
      <div
        id={notificationId}
        className="add_to_cart_notification animated hide"
        data-testid="cart-notification"
      >
        <span>{confirmationMessage}</span>
        <FontAwesomeIcon icon="check-circle" />
      </div>
    </Button>
  );
}

export default CartStatus;
